import React from 'react';

import { useTheme } from '@mui/material/styles';
import { IconButton, AppBar, Toolbar } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import { useBreakpoint } from 'common/hooks';

import Logo from './Logo';

const TopBar = ({ handleDrawerToggle }) => {
    const theme = useTheme();
    const breakpoint = useBreakpoint();
    const isDarkMode = theme.palette.mode === 'dark';

    if (['md', 'lg', 'xl'].includes(breakpoint)) return null;

    return (
        <AppBar
            position={['xs', 'sm'].includes(breakpoint) ? 'fixed' : 'static'}
            sx={{
                backgroundColor: 'rgba(242, 244, 249, 1)',
                boxShadow: isDarkMode ? 'none' : null,
                color: '#ffffff',
                height: '52px',
                justifyContent: 'center',
            }}
        >
            <Toolbar>
                <IconButton
                    onClick={handleDrawerToggle}
                    sx={{
                        '& svg path': {
                            fill: 'red !important',
                        },
                    }}
                >
                    <Logo width={'30px'} />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};

TopBar.propTypes = {
    handleDrawerToggle: PropTypes.func,
};

export default TopBar;
